import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
export default {
  props: {
    value: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      player: null
    };
  },
  computed: {
    // 是否展示弹窗
    isShowPop: function isShowPop() {
      return this.value > -1;
    }
  },
  watch: {
    isShowPop: function isShowPop() {
      if (!this.isShowPop) return;
      var vid = this.setting.演员列表[this.value].vid;
      this.playVideo(vid);
      this.scroll(this.value); //  暂停头部视频播放

      this.eventBus.$emit('stopVideo');
    }
  },
  methods: {
    close: function close() {
      this.$emit('input', -1); // 暂停播放

      this.player.pause(); // 继续头部视频播放

      this.eventBus.$emit('playVideo');
    },
    selectActor: function selectActor(k) {
      this.$emit('input', k);
      var vid = this.setting.演员列表[k].vid;
      this.playVideo(vid);
      this.scroll(k);
    },
    // 播放视频
    playVideo: function playVideo(vid) {
      if (!vid) return;

      if (this.player) {
        this.player.play(vid);
        return;
      }

      var id = 'movie'; // 播放器尺寸

      var playerConfig = {
        containerId: id,
        vid: vid,
        width: '100%',
        height: '100%',
        playerType: 'h5',
        autoplay: true
      };
      var vm = this;
      vm.player = new window.Txplayer(playerConfig);
      vm.player.on('ready', function () {
        if (!vm.player.play) {
          vm.player = null;
          return;
        }

        if (env.isWechat) {
          if (window.WeixinJSBridge) {
            window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
              vm.player.play();
            }, false);
          } else {
            document.addEventListener('WeixinJSBridgeReady', function () {
              window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
                vm.player.play();
              });
            }, false);
          }
        } else {
          vm.player.play();
        }
      });
    },
    // 滚动
    scroll: function scroll(index) {
      var _this = this;

      this.$nextTick(function () {
        var list = _this.$refs.list;
        var item = list.querySelector('.item');
        list.scrollLeft = item.clientWidth * (index - 1.4);
      });
    }
  }
};